import { render, staticRenderFns } from "./serveXieYiGuanLi.vue?vue&type=template&id=017bf646&scoped=true&"
import script from "./serveXieYiGuanLi.vue?vue&type=script&lang=js&"
export * from "./serveXieYiGuanLi.vue?vue&type=script&lang=js&"
import style0 from "./serveXieYiGuanLi.vue?vue&type=style&index=0&id=017bf646&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017bf646",
  null
  
)

export default component.exports